<template lang="pug">
  transition(name="slide")
    .Login
      .header
        h1.title.u-text-width-bold
          | {{$t('auth.field.login')}}

      .content
        form.form(
        @submit.stop.prevent="onSubmitClick")

          .col
            .line-form-container(
            :class="[{ 'is-danger': veeErrors.has('email') }, { 'filled' : user.email }]")
              label.line-form-label
                | {{$t('generic.field.email')}}
              input.line-form-control(
              name="email"
              autocomplete="email"
              type="text"
              v-model="user.email"
              :data-vv-as="$t('generic.field.email')"
              v-validate="'required|email|max:128'")

          .col.password
            .line-form-container(
            :class="[{ 'is-danger': veeErrors.has('password') }, { 'filled' : user.password }]")
              label.line-form-label
                | {{$t('generic.field.password')}}
              input.line-form-control(
              name="password"
              autocomplete="current-password"
              :type="password_type"
              v-model="user.password"
              :data-vv-as="$t('generic.field.password')"
              v-validate="'required|min:6|max:128'")
              button.show-toggle.btn.btn-icon(
              type="button" @click="showPassword")
                IconEyeOff(v-if="password_type === 'password'")
                IconEye(v-else)

          .col.submit
            button.btn.btn-primary(
            type="submit"
            :disabled="is_form_loading")
              Loading(v-if="is_form_loading")
              span(v-else) {{$t('auth.action.sign_in')}}

          Modal(
            v-if="mailResendButtonVisible"
            :acceptText=" $t('auth.action.activation_question_ok_title') "
            :denyText=" $t('generic.action.cancel')  "
            type="danger"
            :is_loading="$wait.is('deleteRole')"
            @onAccept="onResendClick"
            @onDeny="onResendCancelClick")
            p {{ $t('auth.msg.activation_resend_question') }}

      .footer
        p
          router-link.u-color-blue(
          :to="{ name: 'forgot-password' }") {{$t('auth.msg.forgot_pass_msg')}}
        p.register
          | {{ $t('auth.msg.register_msg') + ' '}}
          router-link.u-color-blue(
          :to="{ name: 'register' }") {{$t('auth.msg.try_msg')}}

</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'Login',

    components: {

    },

    data () {
      return {
        mailResendButtonVisible: false,
        typePassword: false,
        user: {
          email: '',
          password: ''
        }
      }
    },

    computed: {

      ...mapGetters('App', [
        'is_production'
      ]),

      password_type () {
        return this.typePassword ? 'text' : 'password'
      },

      is_form_loading () {
        return this.$wait.is('login')
      }

    },

    methods: {

      ...mapActions('Auth', [
        'login'
      ]),

      ...mapActions('Auth', [
        'resendEmail'
      ]),

      ...mapActions('App', [
        'langChange'
      ]),

      ...mapMutations('App', [
        'RESET'
      ]),

      ...mapMutations('Auth', [
        'UPDATE_FORGOT_PASS_SUCCESS'
      ]),

      showPassword () {
        this.typePassword = !this.typePassword
      },

      async onSubmitClick () {
        const isValidForm = await this.$validator._base.validateAll()
        if (!isValidForm)
          return

        if (this.is_production)
          this.$refs.invisibleRecaptcha.execute()
        else
          this.submit()
      },

      submit () {
        this.login(this.user)
        .then(res => {
          this.$router.push({
            name: 'welcome'
          })
          window.localStorage.setItem('loginEmail', this.user.email)
        })
        .catch(err => {
          if(err.data.code === "9.11")
            this.mailResendButtonVisible = true
          else
            this.showErrorToast(this.$getErrorMessage(this, err))

          if (this.is_production)
            this.$refs.invisibleRecaptcha.reset()
        })
      },

      async onResendClick() {
        try {
          await this.resendEmail(this.user.email)
          this.showSuccessToast(this.$t('auth.msg.success_mail_activation_resend'))
          this.mailResendButtonVisible = false
        }
        catch (err) {
          this.mailResendButtonVisible = false
          this.showErrorToast(this.$t('auth.msg.register_form_fail_mail_activation'))
        }
      },

      onResendCancelClick() {
        this.mailResendButtonVisible = false
      },

      onCaptchaVerify(response) {
        this.user.captcha_response = response
        this.submit()
      }

    },

    beforeMount() {
      this.RESET()
      const lang = this.$route.params.lang
      if (lang)
        this.langChange({ lang : lang });
    },

    mounted() {
      this.UPDATE_FORGOT_PASS_SUCCESS(false)
      const lastUsedEmail = window.localStorage.getItem('loginEmail')
      if (lastUsedEmail)
        this.user.email = lastUsedEmail
    }
  }
</script>

<style lang="scss" scoped>

  .slide {
    &-enter-active, &-leave-active {
      opacity: 1;
      transform: translateX(0%);
      transition: $transition-normal;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateX(-100%);
    }
  }

  .Login {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .header {
      margin-bottom: 20px;
      width: 100%;
      max-width: 400px;
      text-align: left;
    }

    .content {
      width: 100%;
      max-width: 400px;
    }

    .footer {
      text-align: center;
      width: 100%;
      max-width: 400px;
      margin-top: 30px;
      text-align: center;

      p {
        &.register {
          width: 100%;
          max-width: 400px;
          position: absolute;
          bottom: 45px;

          @media only screen and (max-height: 580px) {
            position: unset;
            margin-top: 10px;
          }
        }
      }
    }

    @media only screen and (max-width:767px) {
      .header {
        max-width: unset;
      }
      .content {
        max-width: unset;
      }
      .footer {
        max-width: unset;

        p {
          &.register {
            max-width: unset;
          }
        }
      }
    }
  }

  .col {

    + .col {
      margin-top: 40px;
    }

    &.password {
      position: relative;

      .show-toggle {
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: transparent;
        box-shadow: none;
        border-color: transparent;

        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }

    &.submit {
      margin-top: 50px;

      .btn {
        width: 100%;
      }
    }

  }
</style>
